import { authService } from "myfirebase";
import React, { useState } from "react";
import Button from "./buttons/Button";
import InputButton from "./buttons/InputButton";

const CheckYourEmail = ({ userEmailAddress }) => {
  const [showChangeEmailPage, setShowChangeEmailPage] = useState(false);
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [
    showSignOutButtonInChangeEmailPage,
    setShowSignOutButtonInChangeEmailPage,
  ] = useState(false);

  const onChange = (event) => {
    const {
      target: { value },
    } = event;
    setEmail(value);
  };

  const checkEmailVerified = () => {
    window.location.reload(false);
  };

  const resendVerificationEmail = () => {
    authService.currentUser.sendEmailVerification();
    alert("Sent the verification email again.");
  };

  const changeEmail = async (event) => {
    event.preventDefault();
    try {
      await authService.currentUser.updateEmail(email).then(function () {
        alert("email address edited");
      });
      await setShowChangeEmailPage(false);
      await window.location.reload(false);
    } catch (error) {
      setError(error.message);
      setShowSignOutButtonInChangeEmailPage(true);
    }
  };

  const userEmailService = "https://" + userEmailAddress.split("@").pop();

  return (
    <>
      <div
        style={{
          position: "fixed",
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          backdropFilter: "blur(20px)",
          top: 0,
          left: 0,
        }}
      />
      <div
        style={{
          height: "80%",
          width: "90%",
          position: "fixed",
          backgroundColor: "white",
          top: "10%",
          borderRadius: "15px",
          boxShadow: "rgba(0, 0, 0, 0.5) 0px 0px 30px",
          textAlign: "center",
          overflowY: "auto",
          left: 0,
          right: 0,
          marginLeft: "auto",
          marginRight: "auto",
          maxWidth: "1000px",
        }}
      >
        <div style={{ height: "calc(100% - 325px)", overflowY: "auto" }}>
          <h1 style={{ margin: "30px", marginTop: "60px" }}>
            Please click the link sent by email
          </h1>
          <h3 style={{ margin: "30px", marginTop: "60px" }}>
            Please make sure that your email is correct.
          </h3>
          <h3 style={{ margin: "30px" }}>
            Click the link in the email sent to
            <span> </span>
            <a
              style={{ color: "#1877f3" }}
              href={userEmailService}
              target="_blank"
              rel="noreferrer"
            >
              {userEmailAddress}
            </a>
          </h3>
        </div>
        <div
          style={{
            position: "absolute",
            width: "100%",
            bottom: "0px",
            backgroundColor: "white",
          }}
        >
          <div style={{ height: "25px" }} />
          <Button
            width="calc(80% + 30px)"
            maxWidth="750px"
            minWidth="100px"
            backgroundColor="#1877f3"
            color="white"
            zoom
            onClick={checkEmailVerified}
          >
            I've verified my email address by clicking the link
          </Button>
          <div style={{ height: 15 }} />
          <Button
            width="calc(80% + 30px)"
            maxWidth="750px"
            minWidth="100px"
            backgroundColor="transparent"
            color="#1877f3"
            zoom
            onClick={resendVerificationEmail}
          >
            Resend the verification email
          </Button>
          <div style={{ height: 15 }} />
          <Button
            width="calc(80% + 30px)"
            maxWidth="750px"
            minWidth="100px"
            backgroundColor="transparent"
            color="#1877f3"
            zoom
            onClick={() => {
              setShowChangeEmailPage(true);
            }}
          >
            Change my email address
          </Button>
          <div style={{ height: 15 }} />
          <Button
            width="calc(80% + 30px)"
            maxWidth="750px"
            minWidth="100px"
            backgroundColor="transparent"
            color="#1877f3"
            zoom
            onClick={() => {
              authService.signOut();
            }}
          >
            Sign out and retry
          </Button>
          <div style={{ height: "30px" }} />
        </div>
      </div>
      {showChangeEmailPage ? (
        <div
          style={{
            top: "12.5%",
            height: "75%",
            width: "80%",
            position: "fixed",
            backgroundColor: "white",
            borderRadius: "15px",
            boxShadow: "rgba(0, 0, 0, 0.5) 0px 0px 30px",
            textAlign: "center",
            overflow: "auto",
            left: "0",
            right: "0",
            marginLeft: "auto",
            marginRight: "auto",
            maxWidth: "800px",
          }}
        >
          <button
            className="material-icons"
            style={{
              position: "absolute",
              top: "15px",
              right: "15px",
              borderRadius: "15px",
              border: "transparent",
              cursor: "pointer",
              fontSize: "30px",
              backgroundColor: "transparent",
              color: "grey",
              padding: "0",
            }}
            onClick={() => {
              setShowChangeEmailPage(false);
            }}
          >
            cancel
          </button>
          <h1
            style={{
              margin: "30px",
              marginTop: "60px",
              marginBottom: "90px",
            }}
          >
            Change Email Address
          </h1>
          <form onSubmit={changeEmail}>
            <input
              name="email"
              type="text"
              placeholder="Email"
              required
              value={email}
              onChange={onChange}
              style={{
                display: "block",
                marginLeft: "auto",
                marginRight: "auto",
                marginTop: "30px",
                width: "80%",
                maxWidth: "750px",
                minWidth: "100px",
                padding: "15px",
                borderRadius: "11.25px",
                border: "none",
                backgroundColor: "whitesmoke",
              }}
            />
            <div style={{ color: "#ff5f52" }}>{error}</div>
            <input
              type="submit"
              value="Change email address"
              style={{
                padding: "15px",
                width: "calc(80% + 30px)",
                maxWidth: "750px",
                minWidth: "100px",
                marginTop: "60px",
                borderRadius: "15px",
                border: "none",
                backgroundColor: "#1877f3",
                color: "white",
                cursor: "pointer",
              }}
            />
          </form>
          {showSignOutButtonInChangeEmailPage ? (
            <button
              style={{
                padding: "15px",
                width: "calc(80% + 30px)",
                maxWidth: "750px",
                minWidth: "100px",
                marginTop: "60px",
                borderRadius: "15px",
                border: "none",
                backgroundColor: "white",
                color: "#1877f3",
                cursor: "pointer",
              }}
              onClick={() => {
                setShowChangeEmailPage(false);
                authService.signOut();
              }}
            >
              Sign out and retry if you need
            </button>
          ) : (
            <></>
          )}
          <h3 style={{ marginTop: "calc(10vh + 20px)", margin: "30px" }}>
            If you wrote the wrong email, you can change it here.
          </h3>
          <button
            style={{
              padding: "15px",
              width: "calc(80% + 30px)",
              maxWidth: "750px",
              minWidth: "100px",
              marginTop: "60px",
              borderRadius: "15px",
              border: "none",
              backgroundColor: "white",
              color: "#F02849",
              cursor: "pointer",
            }}
            onClick={() => {
              setShowChangeEmailPage(false);
            }}
          >
            Cancel
          </button>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default CheckYourEmail;
